var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoMoneyFromBracketDuotone = function SvgIcoMoneyFromBracketDuotone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M128 96v352c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V96zm64 288c35.3 0 64 28.7 64 64h-64zm32-112c0-44.2 43-80 96-80s96 35.8 96 80-43 80-96 80-96-35.8-96-80m160 176c0-35.3 28.7-64 64-64v64z",
    style: {
      opacity: 0.4
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 64c-17.7 0-32 14.3-32 32v64c0 17.7-14.3 32-32 32S0 177.7 0 160V96C0 43 43 0 96 0h448c53 0 96 43 96 96v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7-14.3-32-32-32z",
    className: "ico-money-from-bracket-duotone_svg__fa-primary"
  })));
};
export default SvgIcoMoneyFromBracketDuotone;